const zh = {
  title: '座位预约系统',
  exit: "退出",
  code: "激活码",
  timeInfo: '激活码有效时间：3分钟',
  tipe: ' 微信搜索“一考即过座位预约”小程序使用该激活码',
  copy: '点我复制',
  nextTime: '下次再说',
  tab: {
    orders: '座位预约',
    query: '记录查询',
  },
  common: {
    error: '调用接口失败',
    success: '操作成功！',
    yes: '是的',
    cancel: '取消',
    allFloor: '全部',
    tip: '提示',
    closing: '已闭馆或已约满, 请选择其他时间预约',
  },
  language: {
    change: '请选择',
    en: 'EN',
    zh: 'ZH',
  },
  //登录页面
  login: {
    welcome: "欢迎使用",
    noticeTitle: "系统公告",
    system: "座位预约系统",
    loginPass: '账号密码登录',
    noNoticeDes: "暂无通知公告",
    userNamePle: "请输入账号",
    passwordPle: "请输入密码",
    codePle: "请输入验证码",
    codeGet: '获取验证码',
    loginBtnWord: "登录",
    casBtn: '统一登录',
    loginNotice1: "请输入账号密码",
    loginNotice2: "请输入验证码"
  },
  IKnow: '我知道了',
  orderSeat: {
    orderDate: '预约日期',
    orderTime: '预约时间',
    orderLocation: '地点',
    orderSeat: '预约座位',
    viewRecords: '查看预约记录',
    sceneSeat: '此座位需现场预约',
    disableSeat: '此座位暂时不可预约'
  },
  //预约页面
  home: {
    selectTitle1: "场馆选择",
    selectTitle2: "楼层",
    selectTitle3: "日期",
    selectTitle4: "开始/结束时间",
    selectTitle5: "其他选项",
    selectDateTabsTitleFragment: '时长筛选',
    selectDateTabsTitleScope: '时段筛选',
    selectDateTabsAll: '全部',
    selectDateTabsAm: '上午',
    selectDateTabsPm: '下午',

    startTimePlaceHolder: '请选择开始时间',
    endTimePlaceHolder: '请选择结束时间',
    btn: '查询空间',
    window: '窗户',
    power: '电源',
    roomType: '24时预约',
    notice: "点击色块可进入详情页，进行空间预约选择",
    emptyNotice: "暂无可选择空间，请前往左侧更改筛选项",
    statusNotice2: '不可用',
    statusNotice1: '可用',
    search: '搜索',
    Monday: '一',
    Tuesday: '二',
    Wednesday: '三',
    Thursday: '四',
    Friday: '五',
    Saturday: '六',
    Sunday: '日',
    build: '场馆',
    floor: '楼层',
    total: '总数',
    free: '可用',
    specialSpace: '特殊空间',
    regularSeatmsg: '您好,没有常用座位哦，快去选座位吧~',
  },
  //我的预约页面
  my: {
    tab1: '今日预约',
    tab2: '历史预约',
    tab3: '违约记录',
    tab4: '门禁记录',
    tip: '点击操作按钮可对记录进行修改',
    empty: '暂无更多记录',
    totalWord: "项数据",
    table1: {
      seat: '座位',
      date: '预约日期',
      time: '开始/结束时间',
      leaveTime: '暂离/返回时间',
      validateTime: '违约日期',
      validateReason: '违约原因',
      code: '凭证号',
      status: '状态',
      status1: "履约中",
      status2: '早退',
      status3: '暂离',
      status4: '预约',
      status5: '已结束',
      status6: '失约',
      status7: '已取消',
      status8: '未签退',
      op: '操作',
      op1: '结束使用',
      op1Message: '是否结束使用？',
      op2: '变更记录',
      op3: '取消预约',
      op3Message: '是否取消预约',
      op3MessageSuccess: '取消成功!今日还可取消【N】次',
      loseEfficacy: '已失效',
    },
    table_access_control: {
      op1: '门禁名称',
      op2: '时间',
      op3: '状态',
    },
  },
  //预约详情页面
  detail: {
    jdzl: '监督暂离',
    tip: '座位布局图可以左右拖动、放大缩小，点击座位即可预约~',
    seat1: '当前可用',
    seat2: '当前有约',
    seat3: '当前暂离',
    power: '电源',
    window: '靠窗',
    computer: '电脑',
    back: '返回场馆列表',
    startTime: '开始时间',
    now: '',
    endTime: '结束时间',
    localMessage: '此座位需要现场预约',
    disableMessage: '此座位暂时不可预约',
    timeScreening: '时段筛选',
    number: '号',
    noAvailable: '暂无可用时段！',
  },
  //消息提示弹窗
  message: {
    maxNotice: "最多只能输入200字", //最多只能输入200字
    orderNotice: "预约类型不能为空", //预约类型不能为空
    timeNotice: "请选择连续时间", //请选择连续时间
    warning: "操作失败,请稍后重试~~",
    success: "操作成功",
    fail: "接口调用失败，请联系管理员~~",
    login_success: "登录成功",
    notice: "提示",
    noticeContent: "请完善账号信息",
    buttonConfirm: "确定",
    buttonCancel: "取消",
    buttonReject: '拒绝',
    maxTimeInfo: "最大预约时长为0分钟, 请重新选择时长！",
    minTimeInfo: "最大预约时长为0分钟, 请重新选择时长！"
  },
  notice: {
    message: '点击左侧菜单可以切换不同的通知哦~'
  }
};

export default zh;



// WEBPACK FOOTER //
// ./src/common/language/zh.js